import React from 'react';

const MoodCheckInModal = ({ isOpen, onSubmit, onSkip, isPostSession = false, palette }) => {
  if (!isOpen) return null;

  // In a pilot the rating takes the coach's color scheme. Everywhere else it keeps its own colors.
  const c = palette
    ? { bg: palette.sidebarBg, edge: palette.accent, kicker: palette.accent, title: palette.textPrimary,
        tile: palette.cardBg, tileHover: palette.hoverBg, label: palette.textPrimary, skip: palette.textSecondary }
    : { bg: '#1a1a2e', edge: '#10B981', kicker: '#10B981', title: '#FFFFFF',
        tile: '#2a2a4a', tileHover: '#3a3a5a', label: '#8BA5B5', skip: '#6B7280' };

  const moods = [
    { value: 1, emoji: '😢', label: 'Struggling' },
    { value: 2, emoji: '😕', label: 'Low' },
    { value: 3, emoji: '😐', label: 'Okay' },
    { value: 4, emoji: '🙂', label: 'Good' },
    { value: 5, emoji: '😊', label: 'Great' }
  ];

  const title = isPostSession 
    ? "How are you feeling now?" 
    : "How are you feeling today?";
  
  const subtitle = isPostSession
    ? "After our conversation..."
    : "Before we begin...";

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: c.bg,
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '400px',
        width: '90%',
        textAlign: 'center',
        border: `1px solid ${c.edge}`
      }}>
        <p style={{ 
          color: c.kicker, 
          fontSize: '14px', 
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }}>
          {subtitle}
        </p>
        <h2 style={{ 
          color: c.title, 
          fontSize: '24px', 
          marginBottom: '24px',
          fontWeight: '600'
        }}>
          {title}
        </h2>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '8px',
          marginBottom: '24px'
        }}>
          {moods.map((mood) => (
            <button
              key={mood.value}
              onClick={() => onSubmit(mood.value)}
              style={{
                flex: 1,
                padding: '16px 8px',
                backgroundColor: c.tile,
                border: '2px solid transparent',
                borderRadius: '12px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = c.edge;
                e.currentTarget.style.backgroundColor = c.tileHover;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'transparent';
                e.currentTarget.style.backgroundColor = c.tile;
              }}
            >
              <span style={{ fontSize: '32px' }}>{mood.emoji}</span>
              <span style={{ 
                color: c.label, 
                fontSize: '11px',
                fontWeight: '500'
              }}>
                {mood.label}
              </span>
            </button>
          ))}
        </div>

        <button
          onClick={onSkip}
          style={{
            background: 'none',
            border: 'none',
            color: c.skip,
            fontSize: '14px',
            cursor: 'pointer',
            padding: '8px 16px'
          }}
        >
          Skip for now
        </button>
      </div>
    </div>
  );
};

export default MoodCheckInModal;
